<script setup lang="ts">
const route = useRoute();
const isPayOnline24 = computed(() => route.path.includes('pay-online-24'));

</script>
<template>
  <div>
    <ABankChat v-if="!isPayOnline24" typeButton="secondary"/>
    <AHeader></AHeader>
    <slot />
    <AFooter></AFooter>
  </div>
</template>
